<template>
  <el-dialog :visible.sync="visible" title="VIP信息管理" width="80%" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm"  >
         <el-form-item :label="`用户ID：${dataForm.memberCode}`" prop="memberCode">
         </el-form-item>
          <el-form-item>
          <el-button type="primary" @click="openAddDialog()">新增VIP</el-button>
        </el-form-item>
      </el-form>
     <el-table :data="dataList" border style="width: 100%;" v-loading="loading">
        <el-table-column label="VIP等级" header-align="center" align="center">
          <template v-slot="scope">
            {{ formatVipLevel(scope.row.vipLevel) }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="VIP开始时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="endTime" label="VIP结束时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" header-align="center" align="center">
          <template v-slot="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ formatStatus(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="获取方式" header-align="center" align="center">
          <template v-slot="scope">
            {{ formatSourceType(scope.row.sourceType) }}
          </template>
        </el-table-column>
        <el-table-column prop="orderId" label="关联订单ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="remarks" label="备注" header-align="center" align="center"></el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="200">
          <template v-slot="scope">
            <el-button size="mini" v-if="scope.row.status === 4" type="success" @click="updateStatus(scope.row, 0)">启用</el-button>
            <el-button size="mini" v-if="scope.row.status === 1" type="danger" @click="updateStatus(scope.row, 4)">禁用</el-button>
            <el-button size="mini" v-if="scope.row.status ===0 ||scope.row.status === 4"  type="danger" @click="deleteVipCard(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
    </template>

    <!-- 新增VIP弹窗 -->
    <el-dialog :visible.sync="addVipVisible" title="新增VIP" width="600px" :close-on-click-modal="false" append-to-body>
      <el-form :model="vipForm" :rules="vipRule" ref="vipForm" label-width="120px">
        <el-form-item label="VIP等级" prop="vipLevel">
          <el-select v-model="vipForm.vipLevel" placeholder="请选择VIP等级" style="width: 100%">
            <el-option label="试用vip" value="1"></el-option>
            <el-option label="月卡vip" value="2"></el-option>
            <el-option label="季卡vip" value="3"></el-option>
            <el-option label="年卡vip" value="4"></el-option>
            <el-option label="永久vip" value="5"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button @click="addVipVisible = false">取消</el-button>
        <el-button type="primary" @click="submitVip()">确定</el-button>
      </template>
    </el-dialog>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      addVipVisible: false,
      loading: false,
      dataList: [],
      dataForm: {
        memberCode: ''
      },
      vipForm: {
        memberCode: '',
        vipLevel: '',
        startTime: '',
        endTime: '',
        status: 0,
        sourceType: '',
        orderId: '',
        remarks: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {}
    },
    vipRule () {
      return {
        vipLevel: [
          { required: true, message: '请选择VIP等级', trigger: 'change' }
        ],
        startTime: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    init (memberCode) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.dataForm.memberCode = memberCode
        console.log(this.dataForm.memberCode,"id3")
        if (this.dataForm.memberCode) {
           this.$http.get(`/user/user/${this.dataForm.memberCode}`).then(({ data: res }) => {
            if (res.code !== 0) {
            return this.$message.error(res.msg)
           }
          this.dataForm = {
          ...this.dataForm,
          ...res.data,
          memberCode: memberCode
         }
      }).catch(() => {})
          this.getInfo()
        }
      })
    },
    formatSourceType(status) {
      const statusMap = {
        1: '充值购买',
        2: '签到赠送',
        3: '邀请奖励',
        4: '活动奖励',
        5: '系统赠送'
      }
      return statusMap[status] || '未知状态'
    },
    formatVipLevel(status) {
      const statusMap = {
        1: '试用vip',
        2: '月卡vip',
        3: '季卡vip',
        4: '年卡vip',
        5: '永久vip'
      }
      return statusMap[status] || '未知状态'
    },
    formatStatus(status) {
      const statusMap = {
        0: '待生效',
        1: '生效中',
        2: '已过期',
        3: '已使用完',
        4: '禁用中'
      }
      return statusMap[status] || '未知状态'
    },
    getStatusType(status) {
      const typeMap = {
        0: 'info',
        1: 'success',
        2: 'warning',
        3: 'danger',
        4: 'danger'
      }
      return typeMap[status] || 'info'
    },
    // 获取信息
    getInfo () {
      this.loading = true
      this.$http.get(`/user/user/vip/subscriptions/${this.dataForm.memberCode}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataList = res.data || []
      }).catch(() => {
        this.$message.error('获取VIP信息失败')
      }).finally(() => {
        this.loading = false
      })
    },
    // 打开新增弹窗
    openAddDialog () {
      this.addVipVisible = true
      this.vipForm = {
        userId: this.dataForm.memberCode,
        vipLevel: '',
        startTime: '',
        endTime: '',
        status: 0,
        sourceType: '',
        orderId: '',
        remarks: ''
      }
      this.$nextTick(() => {
        this.$refs['vipForm'] && this.$refs['vipForm'].resetFields()
      })
    },
    // 提交VIP信息
    submitVip () {
      this.$refs['vipForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http.post('/user/user/vip/subscription', this.vipForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message.success('新增VIP成功')
          this.addVipVisible = false
          this.getInfo()
        }).catch(() => {
          this.$message.error('新增VIP失败')
        })
      })
    },
    deleteVipCard(row){
      this.$confirm("确定删除", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`user/user/vip/subscription/${row.id}`).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message.success('已删除')
          this.getInfo()
        }).catch(() => {
        })
      }).catch(() => {})
    },
    updateStatus (row, status) {
      this.$confirm(`确定要${status === 4 ? '禁用' : '启用'}此VIP吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.put("/user/user/vip/level", {"subscriptionId":row.id, "status":row.status}).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message.success(`${status === 4 ? '禁用' : '启用'}成功`)
          this.getInfo()
        }).catch(() => {
          this.$message.error(`${status === 4 ? '禁用' : '启用'}失败`)
        })
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.memberCode ? 'post' : 'put']('/user/user/vip/subscriptions', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
